import type { FC } from 'react';
import React, { useState } from 'react';
import cn from 'classnames';

import { INITIAL, INN_FALSE, INN_TRUE, PENDING } from '../../config';
import type { TInnStatuses, TStatuses, TRedirectInfo } from '../../models';
import { useRequestCode } from '../../layouts/sms-layout/hooks/use-request-code';

import { FormContext } from './context';
import type { TForm } from './models';
import { onSubmit } from './helpers/submit-helper';

export const Form: FC<TForm> = ({
    FinalForm,
    Safeguard,
    children,
    fields,
    formId,
    fullWidth = false,
    isMobile,
    redirectPathTemplate,
    safeguardText,
    styles,
}) => {
    const [status, setStatus] = useState<TStatuses>(INITIAL);
    const [token, setToken] = useState<string | null>(null);

    // useRequestCode нельзя положить в sms-layout, потому что до sms-layout ход может и не дойти.
    // т.к. есть кейс когда форма отправляется без запроса и проверки кода
    const { request: requestCode, state: requestCodeState } = useRequestCode();
    const [innStatus, setInnStatus] = useState<TInnStatuses>(
        fields?.includes('inn') ? INN_TRUE : INN_FALSE
    );
    const [redirectInfo, setRedirectInfoImpl] = useState<TRedirectInfo>({ redirectPathTemplate });
    const isVisibleSafeguard = (status === INITIAL || status === PENDING) && !isMobile;

    const setRedirectInfo = (newRedirectInfo: TRedirectInfo) =>
        setRedirectInfoImpl({ ...redirectInfo, ...newRedirectInfo });

    return (
        <div className={cn(styles.external, styles.form, { [styles.fullWidth]: fullWidth })}>
            {isVisibleSafeguard && <Safeguard text={safeguardText} />}
            <div className={cn(styles.external, styles.container)}>
                <FormContext.Provider
                    value={{
                        status,
                        updateStatus: setStatus,
                        requestCodeState,
                        requestCode,
                        innStatus,
                        setInnStatus,
                        formId,
                        redirectInfo,
                        setRedirectInfo,
                        fields,
                        setToken,
                    }}
                >
                    <FinalForm<Record<string, unknown>>
                        onSubmit={onSubmit(setStatus, setRedirectInfo, formId, innStatus, token)}
                        render={({ handleSubmit }) => (
                            <form onSubmit={handleSubmit}>{children}</form>
                        )}
                    />
                </FormContext.Provider>
            </div>
        </div>
    );
};
